/**
 * メンテナンス中ページ（公開ページ用）
 */

import React from "react";
import "../styles/MaintenancePage.css";

export const MaintenancePage: React.FC = () => {
  return (
    <div className="maintenance-public-page">
      <div className="maintenance-content">
        <div className="maintenance-icon">🔧</div>
        <h1>メンテナンス中</h1>
        <p className="maintenance-message">
          現在、サイトのメンテナンスを行っております。
          <br />
          ご不便をおかけして申し訳ございません。
        </p>
        <p className="maintenance-sub-message">
          しばらく時間をおいてから、再度アクセスしてください。
        </p>
        <div className="maintenance-contact">
          <p>
            お急ぎの場合は、お電話にてお問い合わせください。
            <br />
            <a href="tel:0120-000-000" className="phone-link">
              0120-000-000
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
